module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAXElEQVRIS+2UMQ4AIAgD23+pn9d/YVxMHAw4dDE4V0quDYT4UTwfaeAS3ojMrAMo7o+YYJCsS6oy6CTbYRBb7F2VLXKZqULOFrnot+CjmuYtusX+UcjxZr8p5Ygmex0eGcj/GNAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/hamburger-icon-white.png
// module id = 297
// module chunks = 0